import type { CPTType, TCPDataPointType } from '@/stores/type/cpt.type'
import { createTrace } from '@/utils/cpt/traceUtils'
import type { PlotData, PlotType } from 'plotly.js-basic-dist'
import type { ModeType } from '@/types/chartType'

export const cptChartDataFromCPT = (
	cptData: CPTType | null,
	parameter: keyof TCPDataPointType,
	color: string,
	mode: ModeType = 'marker'
): PlotData[] => {
	if (!cptData) {
		return []
	}
	const x = []
	const y = []
	for (const point of cptData.cptdatapoint_set) {
		if (point[parameter] === null) {
			continue
		}
		if (Math.abs(point[parameter]) >= 999) {
			continue
		}
		x.push(point[parameter])
		y.push(point.z_ref)
	}
	const isEmpty = x
		.filter((value, index) => index % 5 === 0)
		.every((value) => {
			return value === null
		})
	if (isEmpty) {
		return []
	}
	const chartMode = mode === 'line' ? 'text+lines+markers' : 'markers'
	const lineData = createTrace(parameter, x, y, chartMode, 'scatter', color)
	removeInvalidValues(lineData, 0)
	removeInvalidValues(lineData, lineData.x.length - 1)
	return [lineData]
}

function removeInvalidValues(lineData: PlotData, index: number) {
	const re = new RegExp('9{2,}.9+|9{3,}')
	const invalidValue = lineData.x[index]?.toString().match(re)
	if (invalidValue) {
		lineData.x.splice(index, 1)
		lineData.y.splice(index, 1)
	}
}
